import SuccessPage from "../components/SuccessPage";
import { useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { useEffect, useState } from "react";

export const Success = () => {

  const { instance, inProgress } = useMsal();
  const isAuthenticated = instance.getActiveAccount() !== null;


  useEffect(() => {
    
  if (inProgress === InteractionType.None && !isAuthenticated) {
    instance.loginRedirect("/Home");
  }

  }, [instance, inProgress, isAuthenticated]);


  return (
    <>
      <div>
        <div label="Success">
          <SuccessPage />
        </div>
      </div>
    </>
  );
};
